/** Shopify CDN: Minification failed

Line 16:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 17:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 31:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 44:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 45:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 46:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 59:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 65:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 66:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 70:24 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 1 more hidden warnings

**/
class Swatches {
  constructor(container) {
    this.container = container;
    this.selectors = {
      colorSwatchImage: '.grid-product__color-image',
      colorSwatch: '.color-swatch--with-image',
    };

    this.colorImages = this.container.querySelectorAll(this.selectors.colorSwatchImage);
    if (this.colorImages.length) {
      this.swatches = this.container.querySelectorAll(this.selectors.colorSwatch);
      this.colorSwatchHovering();
    }
  }

  colorSwatchHovering() {
    this.swatches.forEach(swatch => {
      swatch.addEventListener('mouseenter', () => this.setActiveColorImage(swatch));

      swatch.addEventListener('touchstart', evt => {
        evt.preventDefault();
        this.setActiveColorImage(swatch);
      }, { passive: true });

      swatch.addEventListener('mouseleave', () => this.removeActiveColorImage(swatch));
    });
  }

  setActiveColorImage(swatch) {
    const id = swatch.dataset.variantId;
    const image = swatch.dataset.variantImage;

    // Unset all active swatch images
    this.colorImages.forEach(el => {
      el.classList.remove('is-active');
    });

    // Unset all active swatches
    this.swatches.forEach(el => {
      el.classList.remove('is-active');
    });

    // Set active image and swatch
    const imageEl = this.container.querySelector('.grid-product__color-image--' + id);
    imageEl.style.backgroundImage = 'url(' + image + ')';
    imageEl.classList.add('is-active');
    swatch.classList.add('is-active');

    // Update product grid item href with variant URL
    const variantUrl = swatch.dataset.url;
    const gridItem = swatch.closest('.grid-item__link');
    gridItem.setAttribute('href', variantUrl);
  }

  removeActiveColorImage(swatch) {
    const id = swatch.dataset.variantId;
    this.container.querySelector(`.grid-product__color-image--${id}`).classList.remove('is-active');
  }
}

export default Swatches;
